import { render, staticRenderFns } from "./RatingView.vue?vue&type=template&id=55b4745a"
import script from "./RatingView.vue?vue&type=script&lang=ts"
export * from "./RatingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports